import type { ReactNode } from "react";
import { cn } from "@/lib/cn";

/**
 * A panel. Hairline border, 6px radius, no shadow — separation comes from
 * the ceramic ground behind it, which is why the ground is not white.
 */
export function Card({
  children,
  className,
  padded = true,
}: {
  children: ReactNode;
  className?: string;
  /** Off for panels that hold a table, so rows can meet the edge. */
  padded?: boolean;
}) {
  return (
    <section
      className={cn(
        "rounded-panel border border-white bg-surface shadow-panel",
        padded && "p-5",
        className,
      )}
    >
      {children}
    </section>
  );
}

export function CardHeader({
  title,
  subtitle,
  action,
  className,
}: {
  title: ReactNode;
  subtitle?: ReactNode;
  action?: ReactNode;
  className?: string;
}) {
  return (
    <header
      className={cn(
        "mb-4 flex flex-col items-start justify-between gap-3 sm:flex-row",
        className,
      )}
    >
      <div className="min-w-0">
        <h2 className="text-[14px] font-bold tracking-[-0.015em] text-ink">
          {title}
        </h2>
        {subtitle ? (
          <p className="text-micro text-muted mt-0.5">{subtitle}</p>
        ) : null}
      </div>
      {action ? (
        <div className="w-full min-w-0 max-w-full overflow-x-auto pb-1 sm:w-auto sm:shrink-0 sm:overflow-visible sm:pb-0">
          {action}
        </div>
      ) : null}
    </header>
  );
}
